<script setup lang="ts">
import NotClearableInforModal from "@/components/RoleAssignment/NotClearableInforModal.vue"
import ElementPersonInCharge from "@/components/RoleAssignment/ElementPersonInCharge.vue"
import roleAssignAccountType from "@/types/responses/roleAssignAccount"
import ActionButtons from "@/components/RoleAssignment/ActionButtons.vue"
import organizationType from "@/types/requests/organizationType"
import getRole from "@/types/responses/getRole"
import { Ref, ref, computed, watch } from "vue"
import accountType from "@/types/account"
import i18n from "@/lang/i18n"

type requestIdsType = {
  assigns: (roleAssignAccountType | accountType)[],
  unassigns: (roleAssignAccountType | accountType)[]
}

const emit = defineEmits(['update:modelValue'])
const props = defineProps<{
  accounts: roleAssignAccountType[]
  displayAssigns: roleAssignAccountType[]
  alreadyAssignedAccountIds: number[]
  selectedRole: getRole | null
  modelValue: requestIdsType
  windowInnerWidth: number
  organizations: organizationType[]
  changeDisplayAssigns: (accounts: roleAssignAccountType[], isAssign: boolean) => void
  loading: boolean
}>()

const selectedByCandidate: Ref<roleAssignAccountType[]> = ref([])
const selectedByAssigned: Ref<roleAssignAccountType[]> = ref([])
const inforModalStatus: Ref<boolean> = ref(false)

const modelValue = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit("update:modelValue", value)
  }
})

const unAssignAccounts = computed(() => {
  if (!props.accounts?.length) return []
  return props.accounts.filter((account) => {
    return !props.displayAssigns.find((assignedAccount) => {
      return assignedAccount.id === account.id
    })
  })
})

function addPersonInCharge() {
  modelValue.value.assigns = modelValue.value.assigns.concat(selectedByCandidate.value)
  props.changeDisplayAssigns(selectedByCandidate.value, true)
  deleteAssignsOrUnassigns(modelValue.value.assigns, modelValue.value.unassigns)
  selectedByCandidate.value = []
}

function clearPersonInCharge() {
  if (!isClearableRolesCount()) return inforModalStatus.value = true
  modelValue.value.unassigns = modelValue.value.unassigns.concat(selectedByAssigned.value)
  props.changeDisplayAssigns(selectedByAssigned.value, false)
  deleteAssignsOrUnassigns(modelValue.value.unassigns, modelValue.value.assigns)
  selectedByAssigned.value = []
}

function selectAll() {
  selectedByCandidate.value = JSON.parse(JSON.stringify(unAssignAccounts.value))
}

function isClearableRolesCount() {
  let isClearable = true
  selectedByAssigned.value.forEach((account: roleAssignAccountType) => {
    if (account.roles?.length == 1 && account.roles[0]?.id == props.selectedRole?.id) {
      return isClearable = false
    }
  })
  return isClearable
}

function deleteAssignsOrUnassigns(deleteValues: (roleAssignAccountType | accountType)[], accounts: (roleAssignAccountType | accountType)[]) {
  deleteValues.forEach((deleteValue) => {
    const index = accounts.findIndex((account: roleAssignAccountType | accountType) => account.id === deleteValue.id)
    if (index !== -1) accounts.splice(index, 1)
  })
}

function filterByAccounts(accounts: roleAssignAccountType[]) {
  let filteredAccounts: roleAssignAccountType[] = []
  accounts.forEach((account: roleAssignAccountType) => {
    const isIncluededAccount = selectedByCandidate.value.findIndex((selectedAccount: roleAssignAccountType) => {
      return selectedAccount.id == account.id
    }) != -1
    if (isIncluededAccount) filteredAccounts.push(account)
  })
  selectedByCandidate.value = filteredAccounts
}

watch(() => props.accounts, (value) => {
  if (selectedByCandidate.value?.length) filterByAccounts(value)
})
</script>
<template>
  <v-row
    class="checkbox-with-number-text-form mb-2"
  >
    <v-col>
      <ElementPersonInCharge
        :title="i18n.global.t('pages.roleAssignment.form.result')"
        :accounts="unAssignAccounts"
        v-model="selectedByCandidate"
        :alreadyAssignedAccountIds="[]"
        :organizations="organizations"
        :displayIcon="false"
        :loading="props.loading"
      />
    </v-col>
    <v-col cols="1">
      <div class="text-center" style="margin-top: 100px;">
        <ActionButtons
          :action="addPersonInCharge"
        >
          ▶︎
        </ActionButtons>
        <ActionButtons
          :action="clearPersonInCharge"
        >
          ◀︎
        </ActionButtons>
        <ActionButtons
          :action="selectAll"
        >
          {{ i18n.global.t('pages.roleAssignment.form.allSelect') }}
        </ActionButtons>
      </div>
    </v-col>
    <v-col>
      <ElementPersonInCharge
        :title="i18n.global.t('pages.roleAssignment.form.targetUser')"
        :accounts="props.displayAssigns"
        v-model="selectedByAssigned"
        :alreadyAssignedAccountIds="props.alreadyAssignedAccountIds"
        :organizations="organizations"
        :displayIcon="true"
        :loading="props.loading"
      />
    </v-col>
  </v-row>
  <NotClearableInforModal
    v-model="inforModalStatus"
  />
</template>